export default __webpack_public_path__ + "static/media/prev-purple.496c0a17.svg";